import { useRepositorySuspenseQuery } from '@mews-commander/data-access';

export const useAttachmentLibraryAttachment = ({ attachmentId }: { attachmentId: string }) => {
    const { data: attachment } = useRepositorySuspenseQuery(
        'reservationContractAttachments',
        'getAll',
        {},
        { select: ({ attachments }) => attachments?.find(({ id }) => id === attachmentId) }
    );
    return attachment;
};
